define(['app/models/translator', 'crypto-js/sha256', 'crypto-js/md5', 'lz-string-master/libs/lz-string'], function (
    translator,
    sha256,
    md5,
    lzString
) {
    var helpers = {};
    helpers.l = {};

    helpers.uuid = function () {
        'use strict';
        var t =
                ('undefined' != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                ('undefined' != typeof msCrypto &&
                    'function' == typeof msCrypto.getRandomValues &&
                    msCrypto.getRandomValues.bind(msCrypto)),
            e = new Uint8Array(16);

        function n() {
            if (!t) throw new Error('crypto.getRandomValues() not supported.');
            return t(e);
        }
        for (var o = [], r = 0; r < 256; ++r) o.push((r + 256).toString(16).substring(1));
        return (function (t, e, r) {
            'string' == typeof t && ((e = 'binary' === t ? new Uint8Array(16) : null), (t = null));
            var u = (t = t || {}).random || (t.rng || n)();
            if (((u[6] = (15 & u[6]) | 64), (u[8] = (63 & u[8]) | 128), e)) {
                for (var i = r || 0, d = 0; d < 16; ++d) e[i + d] = u[d];
                return e;
            }
            return (function (t, e) {
                var n = e || 0,
                    r = o;
                return (
                    r[t[n + 0]] +
                    r[t[n + 1]] +
                    r[t[n + 2]] +
                    r[t[n + 3]] +
                    '-' +
                    r[t[n + 4]] +
                    r[t[n + 5]] +
                    '-' +
                    r[t[n + 6]] +
                    r[t[n + 7]] +
                    '-' +
                    r[t[n + 8]] +
                    r[t[n + 9]] +
                    '-' +
                    r[t[n + 10]] +
                    r[t[n + 11]] +
                    r[t[n + 12]] +
                    r[t[n + 13]] +
                    r[t[n + 14]] +
                    r[t[n + 15]]
                ).toLowerCase();
            })(u);
        })();
    };

    helpers.count_docs = function (filter) {
        let sum = 0;
        filter.forEach((item) => {
            sum += item.doc_count;
        });
        return sum;
    };

    helpers.display_price = function (val) {
        var sum = 0;

        if (typeof val == 'string') {
            val = parseFloat(val);
        }

        if (typeof val == 'number') {
            var tmp = _.clone(partyking.config.currency);
            tmp.value = 100 * val;
            val = tmp;
        }

        if (partyking && partyking.config && partyking.config.retailer) {
            sum = helpers.round(val.value / 100, val.precision);
        } else if (val.value_incl_vat) {
            sum = helpers.round(val.value_incl_vat / 100, val.precision);
        } else {
            sum = helpers.round((val.value * (1 + parseFloat(val.vat / 100))) / 100, val.precision);
        }
        const formatted = helpers.number_format(sum, val.precision, ',', val.separator[partyking.config.locale]);

        sum = `${val.prefix}${formatted}${val.suffix}`;

        return sum;
    };

    helpers.isIE = function () {
        ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;

        return is_ie;
    };

    helpers.value_price = function (val) {
        var sum = helpers.round(
            parseFloat(Math.round((val.value * (1 + parseFloat(val.vat / 100))) / 100)),
            val.precision
        );
        return sum;
    };

    helpers.value_price_no_vat = function (val) {
        var sum = helpers.round(parseFloat(Math.round(val.value / 100)), val.precision);
        return sum;
    };

    helpers.l.translate = function (text, insertValue) {
        var translatedText = false;

        translatedText = translator.translate(helpers.sanitize(text)).fetch();

        if (typeof insertValue !== 'undefined' && typeof translatedText === 'string') {
            translatedText = translatedText.replace('%s', insertValue);
        }

        return translatedText;
    };

    window._t = helpers.l.translate;

    helpers.sanitize = function (text) {
        if (text && text.replace) {
            text = text.replace(/(\r\n|\n|\r)/gm, '');
            text = text.replace('\t', '');
            text = text.replace('	', '');
        }

        return $.trim(text);
    };

    helpers.detectDevice = function () {
        var mobile = 'screen and (max-width: 550px)';
        var tablet = 'screen and (min-width: 551px) and (max-width: 1023px)';
        var desktop = 'screen and (min-width: 1024px)';

        var device = 'desktop';

        if (window.matchMedia) {
            if (window.matchMedia(mobile).matches) {
                device = 'mobile';
            } else if (window.matchMedia(tablet).matches) {
                device = 'tablet';
            } else if (window.matchMedia(desktop).matches) {
                device = 'desktop';
            }
        }

        return device;
    };

    helpers.sha256 = function (val) {
        if (_.isObject(val)) {
            val = JSON.stringify(val);
        }

        return sha256(val).toString();
    };

    helpers.md5 = function (val) {
        if (_.isObject(val)) {
            val = JSON.stringify(val);
        }

        return md5(val).toString();
    };

    helpers.htmlDecode = function (value) {
        return $('<textarea/>').html(value).text();
    };

    helpers.htmlEncode = function (value) {
        return $('<textarea/>').text(value).html();
    };

    helpers.inIframe = function () {
        return !!window.frameElement;
    };

    helpers.compress = function (str) {
        return lzString.compressToEncodedURIComponent(str);
    };

    helpers.decompress = function (str) {
        return lzString.decompressFromEncodedURIComponent(str);
    };

    helpers.isGif = function (val) {
        if (val.toLowerCase) {
            return val.toLowerCase().indexOf('.gif') != -1;
        }

        return false;
    };

    helpers.log = function (text, file) {
        $.get('/log/' + text + '/' + (typeof file != 'undefined' ? file : 'unknown'));
    };

    helpers.number_format = function (number, decimals, decPoint, thousandsSep) {
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number;
        var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
        var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
        var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
        var s = '';

        var toFixedFix = function (n, prec) {
            if (('' + n).indexOf('e') === -1) {
                return +(Math.round(n + 'e+' + prec) + 'e-' + prec);
            } else {
                var arr = ('' + n).split('e');
                var sig = '';
                if (+arr[1] + prec > 0) {
                    sig = '+';
                }
                return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec);
            }
        };

        s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }

        return s.join(dec);
    };

    helpers.round = function (val, decimals) {
        if (!val) {
            return 0;
        }

        val = parseFloat(val);

        return (
            (val / Math.abs(val)) *
            (Math.round((Math.abs(val) + 0.00001) * Math.pow(10, decimals)) / Math.pow(10, decimals))
        );
    };

    helpers.isCrawler = function () {
        var botPattern =
            '(googlebot/|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)';
        var re = new RegExp(botPattern, 'i');
        var userAgent = navigator.userAgent;
        if (re.test(userAgent)) {
            return true;
        } else {
            return false;
        }
    };

    helpers.customerImage = function (image, size) {
        return (
            partyking.config.cdn +
            size +
            'x' +
            size +
            (image.metadata.length > 0 ? '/' + image.metadata : '') +
            '/products/original/' +
            image.image_name +
            '.jpg'
        );
    };

    helpers.productImage = function (name, size) {
        if (name.endsWith('.gif')) {
            return helpers.gifImage(name);
        }

        if (name && name.substr(-4, 1) != '.') {
            name = name + '.jpg';
        }

        return partyking.config.cdn + 'fit-in/' + size + 'x0/products/original/' + name;
    };

    helpers.gifImage = function (name) {
        return partyking.config.cdn + 'gifs/' + name;
    };

    helpers.dynamicallyResizeTextarea = function (textarea, offset) {
        if (!textarea) return;
        const initialHeight = textarea.clientHeight;

        textarea.onfocus = () => {
            if (!textarea.value) textarea.style.height = `${initialHeight - offset}px`;
        };

        textarea.onblur = () => {
            if (!textarea.value) textarea.style.height = `${textarea.clientHeight + offset}px`;
        };
    };

    helpers.isLocalStorageEnabled = function () {
        const test = 'funkardet???';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    };

    helpers.isCookiesEnabled = () => navigator.cookieEnabled;

    helpers.getCookieByName = (cookieName) => {
        const name = cookieName + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');

        for (let i = 0; i < cookieArray.length; i++) {
            let c = cookieArray[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };

    helpers.isElementInViewport = (el) => {
        const gridRect = el.getBoundingClientRect();

        return (
            gridRect.right >= 0 &&
            gridRect.bottom >= 0 &&
            gridRect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            gridRect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    helpers.getArticleStockStatus = (article) => {
        let status = 'unset';

        if (article.status === 0) {
            status = 'discontinued';
        } else if (article.instock > 0) {
            status = 'instock';
        } else if (article.nonstock > 0 || partyking.common.models.shoppingcart.ignoreStock) {
            status = 'ordered';
        } else if (article.nonstock < 1 || !article.nonstock) {
            status = 'outofstock';
        } else {
            status = 'ordered';
        }

        return status;
    };

    helpers.getArticleDisplayStockStatus = (data) => {
        let stockStatus = '';
        if (typeof data === 'string') {
            stockStatus = data;
        } else {
            stockStatus = helpers.getArticleStockStatus(data);
        }

        let displayStockStatus = '';

        switch (stockStatus) {
            case 'instock':
                displayStockStatus = partyking.common.helpers.l.translate('I lager');
                break;
            case 'ordered':
                displayStockStatus = partyking.common.helpers.l.translate('Snart i lager');
                break;
            case 'outofstock':
                displayStockStatus = partyking.common.helpers.l.translate('Tillfälligt slut');
                break;
            case 'discontinued':
                displayStockStatus = partyking.common.helpers.l.translate('Produkten har utgått');
                break;
        }

        return displayStockStatus;
    };

    helpers.createRatingCrown = (fill, productId, index) => {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', '19.693');
        svg.setAttribute('height', '12.623');
        svg.setAttribute('viewBox', '0 0 19.693 12.623');

        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('transform', 'translate(-50.016 -84.269)');
        path.setAttribute(
            'd',
            'M68.028,87.08a1.7,1.7,0,0,0-1.681,1.72,1.756,1.756,0,0,0,.044.39l-3.127,2.239-2.151-4.294a1.737,1.737,0,0,0,.429-1.146,1.681,1.681,0,1,0-3.362,0,1.737,1.737,0,0,0,.429,1.146L56.46,91.429,53.333,89.19a1.755,1.755,0,0,0,.044-.39,1.681,1.681,0,1,0-3.361,0,1.726,1.726,0,0,0,1.191,1.645l1.251,5.509a1.188,1.188,0,0,0,1.156.94h12.5a1.188,1.188,0,0,0,1.156-.94l1.251-5.509A1.726,1.726,0,0,0,69.709,88.8,1.7,1.7,0,0,0,68.028,87.08Z'
        );

        if (fill >= 1) {
            path.setAttribute('fill', '#ffde0c');
        } else if (fill > 0.0) {
            const svgNS = 'http://www.w3.org/2000/svg';
            const defs = document.createElementNS(svgNS, 'defs');

            const linearGradient = document.createElementNS(svgNS, 'linearGradient');
            let uniqueId = `rating-fill-${productId}-${index}`;
            let uniqueIdElement = document.getElementById(uniqueId);
            let uniqueIdSuperIndex = 0;
            while (uniqueIdElement) {
                uniqueId = `rating-fill-${productId}-${index}-${uniqueIdSuperIndex}`;
                uniqueIdElement = document.getElementById(uniqueId);
                uniqueIdSuperIndex++;
            }

            linearGradient.setAttribute('id', uniqueId);

            const stop1 = document.createElementNS(svgNS, 'stop');
            stop1.setAttribute('offset', '0%');
            stop1.setAttribute('stop-color', '#ffde0c');

            const stop2 = document.createElementNS(svgNS, 'stop');
            const stopSwitchPercentage = `${fill * 100}%`;
            stop2.setAttribute('offset', stopSwitchPercentage);
            stop2.setAttribute('stop-color', '#ffde0c');

            const stop3 = document.createElementNS(svgNS, 'stop');
            stop3.setAttribute('offset', stopSwitchPercentage);
            stop3.setAttribute('stop-color', '#d1d1d1');

            const stop4 = document.createElementNS(svgNS, 'stop');
            stop4.setAttribute('offset', '100%');
            stop4.setAttribute('stop-color', '#d1d1d1');

            linearGradient.appendChild(stop1);
            linearGradient.appendChild(stop2);
            linearGradient.appendChild(stop3);
            linearGradient.appendChild(stop4);

            defs.appendChild(linearGradient);

            svg.appendChild(defs);

            path.setAttribute('fill', `url(#${uniqueId})`);
        } else {
            path.setAttribute('fill', '#d1d1d1');
        }
        svg.appendChild(path);

        return svg;
    };

    helpers.getProductById = (productId) => {
        const fetchUrl = `${window.location.origin}/${productId}.json`;
        return fetch(fetchUrl)
            .then((rawResponse) => rawResponse.json())
            .then((response) => {
                return response;
            })
            .catch((error) => {
                throw new Error(error.message);
            });
    };

    helpers.sourceToArticle = (source, sourceVariant) => {
        if (
            typeof sourceVariant.image_name === 'undefined' ||
            typeof sourceVariant.price === 'undefined' ||
            typeof sourceVariant.saleprice === 'undefined' ||
            typeof source.edible === 'undefined' ||
            typeof source.specification === 'undefined'
        ) {
            return false;
        }

        const article = Object.assign({}, sourceVariant);

        const belongs_to_product = {
            id: source.id,
            name: source.name,
            urlname: source.urlname,
        };

        article.belongs_to_product = belongs_to_product;
        article.print = source.product_type === 2;

        if (!article.image_name) {
            article.image_name = source.image_name;
        }

        return article;
    };

    helpers.serializeRatingCrown = (fragment) => {
        const tempDiv = document.createElement('div');
        tempDiv.appendChild(fragment.cloneNode(true));
        const HTMLString = tempDiv.innerHTML;

        return HTMLString;
    };

    // raptor module tracking start
    helpers.trackRaptorModule = (productId, moduleName, redirectUrl) => {
        partyking.common.trigger('itemClick', {
            productId,
            moduleName,
            redirectUrl,
        });
    };

    helpers.setupModuleTracking = (dataElement, anchor) => {
        const module = dataElement.getAttribute('data-module');
        let productId = dataElement.getAttribute('data-id');

        if (!module || !productId) {
            return;
        }

        if (window.raptor) {
            anchor.addEventListener('click', (event) => {
                // work around for adblock
                event.preventDefault();
                helpers.trackRaptorModule(productId, module, anchor.href);
            });
        }
    };

    helpers.initModuleRecentProductTracking = () => {
        const recentProductAnchors = document.getElementsByClassName('recent-product');
        for (const anchor of recentProductAnchors) {
            helpers.setupModuleTracking(anchor, anchor);
        }
    };

    helpers.initModuleSliderTracking = () => {
        const anchors = document.querySelectorAll('.product-image-anchor, .product-specs-anchor');

        for (const anchor of anchors) {
            const productInner = anchor.closest('.product-inner');
            if (!productInner) {
                continue;
            }

            helpers.setupModuleTracking(productInner, anchor);
        }
    };

    return helpers;
});
